import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CustomDashboardStore, MyProjectDashboardStore, ProjectsDataModelRef, ProjectStatsModelRef, ProjectTableRef } from "../domain/dashboard.model";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";

// export const fetchMyProjectStatsData = createAsyncThunk<
//   ProjectStatsModelRef[],
//   void
// >("dashboard/fetchMyProjectStatsData", async () => {
//   return [
//     {
//     title: "Total Projects",
//     subtitle: "10",
//     icon: "PiFolders",
//     percentages: { red: "30%", green: "50%", gray: "20%" },
//   },
//   {
//     title: "On Track",
//     subtitle: "6",
//     icon: "CiFlag1",
//     percentages: { red: "0%", green: "100%", gray: "0%" },
//   },
//   {
//     title: "Completed",
//     subtitle: "2",
//     icon: "AiOutlineFileDone",

//     percentages: { red: "0%", green: "0%", gray: "100%" },
//   },
//   {
//     title: "Delay",
//     subtitle: "2",
//     icon: "GiSandsOfTime",

//     percentages: { red: "100%", green: "0%", gray: "0%" },
//   },
//   {
//     title: "Total Tasks",
//     subtitle: "10",
//     icon: "PiFolders",

//     percentages: { red: "30%", green: "50%", gray: "20%" },
//   },
//   {
//     title: "On Track",
//     subtitle: "6",
//     icon: "CiFlag1",
//     percentages: { red: "0%", green: "100%", gray: "0%" },
//   },
//   {
//     title: "Completed",
//     subtitle: "2",
//     icon: "AiOutlineFileDone",

//     percentages: { red: "0%", green: "0%", gray: "100%" },
//   },
//   {
//     title: "Delay",
//     subtitle: "2",
//     icon: "GiSandsOfTime",

//     percentages: { red: "100%", green: "0%", gray: "0%" },
//   },
//   ];
// });

//   export const fetchUserProjectCountData = createAsyncThunk<ProjectStatsModelRef[],  { projectType: "npms" | "eci" | "custom", id:string } 
// >("dashboard/fetchUserProjectCountData", async ({projectType,id}) => {
//   const url = `${AppConstants.api}/dashboard/user-project-count?projectType=${projectType}&id=${id}`;
//   const response = await api.get<ApplicationResponse<ProjectStatsModelRef[]>>(
//     url
//   );
//   return response.data.data || [];
// });
export const fetchUserProjectCountData = createAsyncThunk<
  ProjectStatsModelRef[],
  { projectType: "npms" | "eci" | "custom"; id: string; plantIds: string[] }
>("dashboard/fetchUserProjectCountData", async ({ projectType, id, plantIds }) => {
  const url = `${AppConstants.api}/dashboard/user-project-count?projectType=${projectType}&id=${id}`;
  const response = await api.post<ApplicationResponse<ProjectStatsModelRef[]>>(url, plantIds);
  return response.data.data || [];
});

  export const fetchUserTaskCountData = createAsyncThunk<ProjectStatsModelRef[],  
  { projectType: "npms" | "eci" | "custom", id:string,departmentId?:string } 
>("dashboard/fetchUserTaskCountData", async ({projectType,id,departmentId=""}) => {
  
  let url = `${AppConstants.api}/dashboard/user-task-count?projectType=${projectType}&id=${id}`;
  if(departmentId && departmentId.length>0)  url=url+`&departmentId=${departmentId}`;
  const response = await api.get<ApplicationResponse<ProjectStatsModelRef[]>>(
    url
  );
  return response.data.data || [];
});

//   export const fetchUserProjectsData = createAsyncThunk<ProjectTableRef[],  { projectType: "npms" | "eci" | "custom",id:string } 
// >("dashboard/fetchUserProjectsData", async ({projectType,id}) => {
//   const url = `${AppConstants.api}/dashboard/user-projects?projectType=${projectType}&id=${id}`;
//   const response = await api.get<ApplicationResponse<ProjectTableRef[]>>(
//     url
//   );
//   return response.data.data || [];
// });
export const fetchUserProjectsData = createAsyncThunk<
  ProjectTableRef[],
  { projectType: "npms" | "eci" | "custom"; id: string; plantIds: string[] }
>("dashboard/fetchUserProjectsData", async ({ projectType, id, plantIds }) => {
  const url = `${AppConstants.api}/dashboard/user-projects?projectType=${projectType}&id=${id}`;
  const response = await api.post<ApplicationResponse<ProjectTableRef[]>>(url, plantIds);
  return response.data.data || [];
});


const myProjectDashboardSlice = createSlice({
  name: "myProjectDashboard",
  initialState: {
    userProjectCountMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    userTaskCountMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    userProjectsMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    
  } as MyProjectDashboardStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProjectCountData.pending, (state, action) => {
        state.userProjectCountMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUserProjectCountData.fulfilled, (state, action) => {
        state.userProjectCountMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUserProjectCountData.rejected, (state, action) => {
        state.userProjectCountMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchUserTaskCountData.pending, (state, action) => {
        state.userTaskCountMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUserTaskCountData.fulfilled, (state, action) => {
        state.userTaskCountMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUserTaskCountData.rejected, (state, action) => {
        state.userTaskCountMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchUserProjectsData.pending, (state, action) => {
        state.userProjectsMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUserProjectsData.fulfilled, (state, action) => {
        state.userProjectsMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUserProjectsData.rejected, (state, action) => {
        state.userProjectsMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      
      
     
  },
});

export default myProjectDashboardSlice.reducer;
